<template>
  <div>
    <div class="layout" v-if="!isAuth">
      <appBar :menus="beforeLoginMenus" v-if="showAppBar" />
      <navigationDrawer :menus="beforeLoginMenus" />
      <v-main>
        <router-view />
      </v-main>
    </div>
    <div class="layout" v-else>
      <v-tour name="myTour" :steps="steps" :callbacks="tourCallbacks"></v-tour>
      <appBar :menus="menus" v-if="showAppBar" />
      <navigationDrawer :menus="menus" />
      <notifications />
      <account-sidebar />
      <v-main>
        <transitionPage>
          <router-view />
        </transitionPage>
      </v-main>
    </div>
  </div>
</template>
<script>
import notifications from "@/components/notifications/index.vue";
import navigationDrawer from "@/views/panel/layout/navigation-drawer/index.vue";
import transitionPage from "@/components/transitionPage/index.vue";
import AccountSidebar from "@/components/AccountSidebar/index.vue";
import appBar from "@/views/panel/layout/app-bar/index.vue";
import { authMixin } from "@/mixins/authMixin";
import UserCenter from "@/services/modules/market/userCenter";
import { mapActions } from "vuex";
import * as types from "@/store/types";
import { UserService } from "@/services";
import dayjs from "dayjs";
import jalaliday from "jalali-plugin-dayjs";
import utc from "dayjs/plugin/utc";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(customParseFormat);

export default {
  name: "publicLayout",
  mixins: [authMixin],
  components: {
    appBar,
    AccountSidebar,
    transitionPage,
    navigationDrawer,
    notifications
  },
  data() {
    return {
      tourCallbacks: {
        onFinish: this.onFinishStepsCallback
      },
      steps: [
        {
          target: '[data-v-step="0"]', // We're using document.querySelector() under the hood
          header: {
            title: "Get Started"
          },
          content: `Discover <strong>Vue Tour</strong>!`
        },
        {
          target: '[data-v-step="1"]',
          content: "An awesome plugin made with Vue.js!"
        },
        {
          target: '[data-v-step="2"]',
          content:
            "Try it, you'll love it!<br>You can put HTML in the steps and completely customize the DOM to suit your needs.",
          params: {
            placement: "top" // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          }
        }
      ],
      menus: [
        { title: this.$t("header.menu.dashborad"), link: "/" },
        {
          title: this.$t("header.menu.wallet.wallet"),
          children: [
            {
              title: this.$t("header.menu.wallet.main"),
              link: "/wallet/main",
              detail: this.$t("header.menu.wallet.mainDetail"),
              icon: "$mainWallet"
            },
            {
              title: this.$t("header.menu.wallet.spot"),
              link: "/wallet/spot",
              detail: this.$t("header.menu.wallet.spotDetail"),
              icon: "$spotWallet"
            },
            {
              title: this.$t("header.menu.wallet.transfer.transfer"),
              detail: this.$t("header.menu.wallet.transfer.transferDetail"),
              icon: "$transferIcon",
              children: [
                {
                  title: this.$t("header.menu.wallet.transfer.transferToMain"),
                  link: "/withdraw?name=IRR",
                  detail: this.$t(
                    "header.menu.wallet.transfer.transfertToMainDetail"
                  ),
                  icon: "$mainWallet"
                },
                {
                  title: this.$t("header.menu.wallet.transfer.transferToSpot"),
                  link: "/operations/transfer",
                  detail: this.$t(
                    "header.menu.wallet.transfer.transfertToSpotDetail"
                  ),
                  icon: "$spotWallet"
                }
              ]
            }
          ]
        },
        {
          title: this.$t("header.menu.dealing.dealing"),
          children: [
            {
              title: this.$t("header.menu.dealing.fastConvert"),
              link: "/operations/exchange",
              detail: this.$t("header.menu.dealing.fastConvertDetail"),
              icon: "$fastConvert"
            },
            {
              title: this.$t("header.menu.dealing.spot"),
              link: `/exchange`,
              detail: this.$t("header.menu.dealing.spotDetail"),
              icon: "$spotMarket",
            },
            {
              title: this.$t("header.menu.dealing.testMarket"),
              link: `/exchange/v-btc_v-usdt`,
              detail: this.$t("header.menu.dealing.testMarketDetail"),
              icon: "$testSpot",
            },
            {
              title: this.$t("header.menu.dealing.ordering"),
              link: "/order",
              detail: this.$t("header.menu.dealing.orderingDetail"),
              icon: "$ordering"
            }
            // {
            //   title: this.$t("header.menu.dealing.perfectMoney"),
            //   link: "/fiat",
            //   detail: this.$t("header.menu.dealing.perfectMoneyDetail"),
            //   icon: "$perfectMoney"
            // }
          ]
        },
        { title: this.$t("header.menu.markets"), link: `/markets` },
        { title: this.$t("header.menu.prices"), link: "/prices" },
        {
          title: this.$t("header.menu.orders.orders"),
          children: [
            {
              title: this.$t("header.menu.orders.openOrders"),
              link: "/open-orders",
              detail: this.$t("header.menu.orders.openOrdersDetail"),
              icon: "$openOrders"
            },
            {
              title: this.$t("header.menu.orders.profitLossLimit"),
              link: "/stop-limit-orders",
              detail: this.$t("header.menu.orders.profitLossLimitDetail"),
              icon: "$profitLossLimit"
            },
            {
              title: this.$t("header.menu.orders.history.history"),
              detail: this.$t("header.menu.orders.history.historyDetail"),
              icon: "$history",
              children: [
                {
                  title: this.$t("header.menu.orders.history.openOrders"),
                  link: "/history/orders-history",
                  detail: this.$t(
                    "header.menu.orders.history.openOrdersDetail"
                  ),
                  icon: "$openOrdersHistory"
                },
                {
                  title: this.$t("header.menu.orders.history.profitLossLimit"),
                  link: "/history/precondition-orders-history",
                  detail: this.$t(
                    "header.menu.orders.history.profitLossLimitDetail"
                  ),
                  icon: "$openOrdersHistory"
                },
                {
                  title: this.$t("header.menu.orders.history.transactions"),
                  link: "/history/p2p-transactions",
                  detail: this.$t(
                    "header.menu.orders.history.transactionsDetail"
                  ),
                  icon: "$transactionsHistory"
                },
                {
                  title: this.$t("header.menu.orders.history.otc"),
                  link: "/history/transaction",
                  detail: this.$t("header.menu.orders.history.otcDetail"),
                  icon: "$profitLossLimitHistory"
                }
              ]
            }
          ]
        },
        {
          title: this.$t("header.menu.investing.investing"),
          children: [
            {
              title: this.$t("header.menu.investing.staking"),
              link: `${process.env.VUE_APP_PUBLIC_BASE_URL}/market/staking`,
              detail: this.$t("header.menu.investing.stakingDetail"),
              icon: "$staking",
              external: true
            },
            {
              title: this.$t("header.menu.investing.partnershipFunds"),
              link: "https://hello.excoino.com/investment/",
              detail: this.$t("header.menu.investing.partnershipFundsDetail"),
              icon: "$partnershipFunds",
              external: true
            },
            {
              title: this.$t("header.menu.investing.uranus"),
              link: "https://hello.excoino.com/investment/uranus",
              detail: this.$t("header.menu.investing.uranusDetail"),
              icon: "$uranus",
              external: true
            }
          ]
        },
        {
          title: this.$t("header.menu.blog"),
          external: true,
          link: `https://excoino.com/blog`
        }
      ],
      beforeLoginMenus: [
        {
          title: this.$t("header.menu.dealing.dealing"),
          children: [
            {
              title: this.$t("header.menu.dealing.spot"),
              link: `/exchange`,
              detail: this.$t("header.menu.dealing.spotDetail"),
              icon: "$spotMarket",
            },
            {
              title: this.$t("header.menu.dealing.testMarket"),
              link: `/exchange/v-btc_v-usdt`,
              detail: this.$t("header.menu.dealing.testMarketDetail"),
              icon: "$testSpot",
            }
          ]
        },
        { title: this.$t("header.menu.markets"), link: `/markets` },
        { title: this.$t("header.menu.prices"), link: "/prices" },
        {
          title: this.$t("header.menu.investing.investing"),
          children: [
            {
              title: this.$t("header.menu.investing.staking"),
              link: `${process.env.VUE_APP_PUBLIC_BASE_URL}/market/staking`,
              detail: this.$t("header.menu.investing.stakingDetail"),
              icon: "$staking",
              external: true
            },
            {
              title: this.$t("header.menu.investing.partnershipFunds"),
              link: "https://hello.excoino.com/investment/",
              detail: this.$t("header.menu.investing.partnershipFundsDetail"),
              icon: "$partnershipFunds",
              external: true
            },
            {
              title: this.$t("header.menu.investing.uranus"),
              link: "https://hello.excoino.com/investment/uranus",
              detail: this.$t("header.menu.investing.uranusDetail"),
              icon: "$uranus",
              external: true
            }
          ]
        },
        {
          title: this.$t("header.menu.blog"),
          external: true,
          link: `https://excoino.com/blog`
        }
      ]
    };
  },
  mounted() {
    if (this.isAuth) {
      UserCenter.checkLogin().then(response => {
        this.setMarketUserInfo(response.data.data);
      });
      this.getUserInfo();
      this.getUserInfoVerify();
      this.getUserSetting();
      this.getUserAccountSetting();
    }
  },
  computed: {
    showAppBar() {
      return this.$route.meta.showAppBar !== false; // Default to true if not set
    }
  },
  methods: {
    ...mapActions({
      setMarketUserInfo: types.marketUserInfo.actions.ACTION_USER_INFO,
      setUserData: types.userInfo.actions.ACTION_USER_INFO,
      setUserVerifyInfo: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO,
      setUserSetting: types.userSetting.actions.SET_USER_SETTING
    }),
    onFinishStepsCallback() {
      localStorage.setItem("tour_status", "off");
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
        const isGlobal = localStorage.getItem("is_global") === "true";
        if (!isGlobal) {
          dayjs.extend(jalaliday);
          dayjs.calendar("jalali").locale("fa");
        }
        this.setGooftinoData(response.data.data);
      });
    },
    getUserInfoVerify() {
      UserService.getVerifyInfo().then(res => {
        this.setUserVerifyInfo(res.data.data);
      });
    },
    getUserSetting() {
      UserService.getSetting().then(res => {
        this.setUserSetting(res.data.data);
      });
    },
    getUserAccountSetting() {
      UserService.getUserAccountSetting().then(res => {
        const theme = res.data.data.theme || "LIGHT";
        // const lang = res.data.data.language || this.$cookies.get("lang");

        // localStorage.setItem("lang", lang);
        // this.$cookies.set("lang", lang);
        //
        const isDark = theme === "DARK";
        this.$vuetify.theme.dark = isDark;
        localStorage.setItem("isDark", isDark);

        if (!res.data.data.language) {
          this.setUserAccountSettings({
            language: this.$cookies.get("lang")
          });
        } else {
          if (this.$cookies.get("userChangeSetting") == "false") {
            this.$cookies.set("lang", res.data.data.language);
          }
        }
        // alert(res.data.data.language)
        // alert(this.$cookies.get("lang"))
        if (res.data.data.language != this.$cookies.get("lang")) {
          if (this.$cookies.get("userChangeSetting") == "true") {
            this.setUserAccountSettings({
              language: this.$cookies.get("lang")
            });
          }
        }

        this.$i18n.locale = this.$cookies.get("lang");
        if (this.$cookies.get("lang") === "fa") {
          this.$vuetify.rtl = true;
          localStorage.setItem("direction", "rtl");
        } else {
          this.$vuetify.rtl = false;
          localStorage.setItem("direction", "ltr");
        }
      });
    },
    setUserAccountSettings(payload) {
      return UserService.saveUserAccountSetting(payload);
    }
  }
};
</script>

<style lang="scss" scoped></style>
